import { SETTINGS } from './types';

const initialState = {};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case SETTINGS.LOAD:
            return {
                ...state,
                ...action.data
            };
        case SETTINGS.LOAD_LITERALS:
            return {
                ...state,
                literals: action.data
            };
        case SETTINGS.RESET:
            return initialState;
        default:
            return state;
    }
};

export default reducer;
